import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

function detectLanguage() {
  const stored = localStorage.getItem("vespera_lang");
  if (stored && translations[stored]) return stored;
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  return translations[nav] ? nav : "en";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage());

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    localStorage.setItem("vespera_lang", code);
    document.documentElement.setAttribute("lang", code);
    setLangState(code);
  }, []);

  const t = useCallback(
    (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
